module.exports = __webpack_public_path__ + "img/g-gift.7e5da331.jpg";